import React from 'react';
import { Link } from 'react-router-dom';
import TableLoader from './TableLoader';
import { formatDate } from './DateDisplay';

const TriagensTable = ({ 
  triagens, 
  loading
}) => {
  if (loading) {
    return <TableLoader />;
  }

  return (
    <div className="table-responsive">
      <table className="table align-items-center mb-0">
        <thead>
          <tr>
            <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Nome do Paciente</th>
            <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Nome dos Pais</th>
            <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Data Triagem</th>
            <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Lead</th>
            <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Terapeuta</th>
            <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Demanda</th>
            <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2 text-center">Tornou-se Paciente?</th>
            <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Ações</th>
          </tr>
        </thead>
        <tbody>
          {triagens.length === 0 ? (
            <tr>
              <td colSpan="8" className="text-center text-xs mb-0 py-4">
                Nenhuma triagem encontrada
              </td>
            </tr>
          ) : (
            triagens.map((triagem) => (
              <tr key={triagem.id}>
                <td className="text-xs mb-0 ps-2">{triagem.patientName || '-'}</td>
                <td className="text-xs mb-0 ps-2">
                  {triagem.parentsName ? (
                    <span>{triagem.parentsName}</span>
                  ) : (
                    <span className="text-muted">-</span>
                  )}
                </td>
                <td className="text-xs mb-0 ps-2">
                  {triagem.screeningDate ? formatDate(triagem.screeningDate) : '-'}
                </td>
                <td className="text-xs mb-0 ps-2">
                  {triagem.referral || '-'}
                </td>
                <td className="text-xs mb-0 ps-2">
                  {triagem.therapistName || triagem.therapist?.name || '-'}
                </td>
                <td className="text-xs mb-0 ps-2">
                  {triagem.demand ? (
                    <span className="badge bg-info">
                      {triagem.demand === 'AVALIACAO' ? 'Avaliação' : 
                       triagem.demand === 'INTERVENCAO' ? 'Intervenção' : 
                       triagem.demand === 'PSICOTERAPIA' ? 'Psicoterapia' : triagem.demand}
                    </span>
                  ) : (
                    '-'
                  )}
                </td>
                <td className="text-xs mb-0 ps-2 text-center">
                  {triagem.patientId ? (
                    <span className="badge bg-info">Sim</span>
                  ) : (
                    <span className="badge bg-danger">Não</span>
                  )}
                </td>
                <td className="text-xs font-weight-bold mb-0 ps-2">
                  <Link to={`/Triagens/Visualizar/${triagem.id}`} title="Visualizar" className="me-3">
                    <i className="bi bi-eye text-info"></i>
                  </Link>
                  <Link to={`/Triagens/Editar/${triagem.id}`} title="Editar" className="me-3">
                    <i className="bi bi-pencil-square text-primary"></i>
                  </Link>
                  <Link to={`/Triagens/Excluir/${triagem.id}`} title="Excluir">
                    <i className="bi bi-trash text-danger"></i>
                  </Link>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default TriagensTable;

